import * as React from "react";

import "./front-template-viewer.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {EnlargedView} from "../../../../../common/enlarged-view/enlarged-view";

import {ImageViewer} from "./image-viewer/image-viewer";

export const FrontTemplateViewer = ({next, images, loading=false, state=null, templateBacks=null}) => cs(
    ["view", (_, next) => UseState({
        /*
            {boolean enlarged, integer key}
        */
        initValue: {enlarged: false, key: 0},
        next,
    })],
    ["enlargedView", ({view}, next) => EnlargedView({
        images: images?.map((url) => ({url})),
        onChangeView: (key) => view.onChange({...view.value, key: key}),
        viewing: view.value.key,
        next,
    })],
    ({view, enlargedView}) => next({
        render: () => (<>
            <div className="front-template-viewer front-template-viewer-g9t">
                {ImageViewer({
                    images: images?.map((img, i) => ({
                        src: img,
                        onClick: () => view.onChange({key: i}),
                    })),
                    loading,
                    onEnlarge: () => enlargedView.show(),
                    state,
                    templateBacks,
                    viewing: view.value.key,
                })}
            </div>
        </>
        ),
        onEnlarge: () => enlargedView.show(),
    }),
);
